var map = {
	"./icon-stats-certificates.svg": 1404,
	"./icon-stats-courses.svg": 1405,
	"./icon-stats-exercises.svg": 1406,
	"./icon-stats-instructors.svg": 1407,
	"./icon-stats-projects.svg": 1408,
	"./icon-stats-rating.svg": 1409,
	"./icon-stats-reviews.svg": 1410,
	"./icon-stats-students.svg": 1411,
	"./icon-stats-video.svg": 1412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1609;